(function() {
    if (document.querySelector('.process')) {
        const $class = 'process';
        const slideCount = document.querySelectorAll(`.${$class}__step`).length;
    
        // Funkcja ustawiająca maksymalną wysokość dla wszystkich elementów .process__square
        function setMaxSquareHeight() {
            const squares = document.querySelectorAll(`.${$class}__square`);
            let maxHeight = 0;
    
            // Znalezienie największej wysokości
            squares.forEach(square => {
                square.style.height = 'auto'; // Resetowanie wysokości, aby poprawnie uzyskać naturalną wysokość
                const height = square.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
    
            // Ustawienie największej wysokości dla wszystkich elementów .process__square
            squares.forEach(square => {
                square.style.height = `${maxHeight}px`;
            });
        }
    
        // Funkcja obliczająca liczbę slajdów na podstawie rozdzielczości
        function getSlideCount() {
            const width = window.innerWidth;
    
            if (width >= 1280) return slideCount - 4;
            if (width >= 992) return slideCount - 3;
            if (width >= 768) return slideCount - 2;
            if (width >= 500) return slideCount - 1;
            return slideCount;
        }
    
        // Funkcja aktualizująca szerokość i położenie bloku
        function updateBlockPosition() {
            const slideCount1 = getSlideCount();
            const conindBlock = document.querySelector(`.${$class}__block`);
            const blockWidthPercentage = 100 / slideCount1;
    
            // Ustawienie szerokości bloku
            conindBlock.style.width = `${blockWidthPercentage}%`;
    
            // Aktualizacja pozycji bloku
            const activeIndex = swiperCompetence.realIndex;
            conindBlock.style.left = `${blockWidthPercentage * activeIndex}%`;
        }
    
        // Funkcja sprawdzająca szerokość ekranu i dodająca/usuwająca klasę
        function checkScreenWidth() {
            const conindElement = document.querySelector(`.${$class}__conind`);
            if (window.innerWidth >= 1280) {
                conindElement.classList.add(`${$class}__conind--disabled`);
            } else {
                conindElement.classList.remove(`${$class}__conind--disabled`);
            }
        }
    
        // Inicjalizacja Swipera
        const swiperCompetence = new Swiper(`.${$class}__carousel`, {
            wrapperClass: `${$class}__ribbon`,
            slideClass: `${$class}__step`,
            direction: 'horizontal',
            loop: false,
            speed: 600,
            navigation: {
                prevEl: `.${$class}__controller--left`,
                nextEl: `.${$class}__controller--right`,
                disabledClass: `conind__controller--disabled-black`,
            },
            pagination: {
                el: `.${$class}__pagination`,
                type: 'bullets',
                bulletElement: 'div',
                bulletClass: `${$class}__circle`,
                bulletActiveClass: `${$class}__circle--active`,
                clickable: false,
            },
            allowTouchMove: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                    allowTouchMove: true,
                    spaceBetween: 0,
                },
                500: {
                    slidesPerView: 2.5,
                    allowTouchMove: true,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 3.5,
                    allowTouchMove: true,
                    spaceBetween: 0,
                },
                992: {
                    slidesPerView: 4.5,
                    allowTouchMove: true,
                    spaceBetween: 0,
                },
                1280: {
                    slidesPerView: slideCount,
                    spaceBetween: 0,
                },
            }
        });
    
        // Wywołanie funkcji na load i resize
        window.addEventListener('load', () => {
            setMaxSquareHeight();
            updateBlockPosition();
            checkScreenWidth(); // Dodanie/ usunięcie klasy na ładowaniu
    
            // Dodanie klasy process__carousel--loaded po załadowaniu wszystkich zadań
            document.querySelector(`.${$class}__carousel`).classList.add(`${$class}__carousel--loaded`);
        });
        window.addEventListener('resize', () => {
            setMaxSquareHeight();
            updateBlockPosition();
            checkScreenWidth(); // Dodanie/ usunięcie klasy przy zmianie rozmiaru
        });
    
        // Aktualizacja pozycji bloku na zmianę slajdu
        swiperCompetence.on('slideChange', updateBlockPosition);
    }
})();
